import { useState } from 'react';

export type FaqItem = {
  q: string;
  a: string;
};

type FaqAccordionProps = {
  items: FaqItem[];
  idPrefix: string;
};

export default function FaqAccordion({ items, idPrefix }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <div className="divide-y divide-foreground-950/10 border-y border-foreground-950/10">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const panelId = `${idPrefix}-panel-${index}`;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                aria-controls={panelId}
                className="w-full flex items-start justify-between gap-6 py-5 text-left cursor-pointer group"
              >
                <span className="flex items-start gap-4">
                  <span className="font-mono text-xs text-primary-500 pt-1">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="font-heading text-base md:text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.q}
                  </span>
                </span>
                <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full border border-foreground-950/15 text-foreground-700 transition-colors group-hover:border-primary-500 group-hover:text-primary-500">
                  <i className={`text-base ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
            </h3>
            <div
              id={panelId}
              hidden={!isOpen}
              className="pb-6 pl-10 pr-4 md:pr-16 text-sm leading-relaxed text-foreground-600"
            >
              {item.a}
            </div>
          </div>
        );
      })}
    </div>
  );
}